import React, { useState, useContext } from "react";
import { Box, Typography, CircularProgress, List, ListItem, TextField, IconButton, Popover, MenuList, MenuItem, useMediaQuery, useTheme } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonIcon from "@mui/icons-material/Person";
import { ThemeContext } from "../../../context/ThemeContext";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import PullToRefresh from 'react-pull-to-refresh';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { getNews } from "../../../api/request/dashboard/dashboard";
import { setNews } from "../../../store/Slices/newsSlice";

export default function News({ searchQuery: externalSearchQuery }) {
  const { darkMode } = useContext(ThemeContext);
  const [searchQuery, setSearchQuery] = useState(externalSearchQuery || "");
  const [anchorEl, setAnchorEl] = useState(null);
  const [newsProvider, setNewsProvider] = useState("");
  const { news = [] } = useSelector((state) => state.news);
  const newsProviderName = [...new Set(news?.map(news => news.newsProviderName))].filter(Boolean);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isRefreshing, setIsRefreshing] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const activeSearch = typeof externalSearchQuery === "string" ? externalSearchQuery : searchQuery;

  const handleRefresh = async () => {
    setIsRefreshing(true); // Start refresh loading
    try {
      const response = await getNews();
      dispatch(setNews(response.data)); // Update Redux store with new news
    } catch (error) {
      console.error("Error fetching news:", error);
    }
    setIsRefreshing(false); // Stop refresh loading
  };

  if (isRefreshing) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="20vh"><CircularProgress /></Box>
    );
  }

  if (!news || news.length === 0) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <Typography variant="h6">{t('nonewsavailable')}</Typography>
      </Box>
    );
  }

  const handleReadMore = (link) => {
    window.open(link, "_blank");
  };

  const handleCloseFilterMenu = () => {
    setAnchorEl(null);
  };

  const handleSelectSymbol = (symbol) => {
    setNewsProvider(symbol === "All" ? "" : symbol);
    setAnchorEl(null);
  };
  const filteredNews = news.filter(news =>
    (newsProvider ? news.newsProviderName === newsProvider : true) &&
    (news.title.toLowerCase().includes(activeSearch.toLowerCase()) ||
      news.newsProviderName.toLowerCase().includes(activeSearch.toLowerCase()))
  );


  return (
    <>
      <Box p={0} sx={{ position: 'relative', height: "calc(100% - 35px)", display: 'flex', flexDirection: 'column' }}>

        <Box sx={{ height: '100%', flex: 1, overflow: 'auto', paddingTop: 1, paddingBottom: isMobile ? 8 : 0 }}>
          <PullToRefresh onRefresh={handleRefresh}>
            <List>
              {filteredNews.map((news) => (
                <ListItem key={news.id} sx={{ marginBottom: 1, borderBottom: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, paddingBottom: 1 }}>
                  <Box onClick={() => handleReadMore(news.link)}>
                    <Typography variant="body2" sx={{ display: "flex", alignItems: "center", marginBottom: 1, color: darkMode ? "var(--lightText)" : 'var(--darkText)', }}>{news.title}</Typography>
                    <Box sx={{ display: "flex", alignItems: "center", marginBottom: 1 }} >
                      <AccessTimeIcon sx={{ marginRight: 1, fontSize: "13px", color: darkMode ? "var(--lightText)" : 'var(--darkText)', }} />
                      <Typography color="textSecondary" sx={{ marginRight: 2, fontSize: "12px" }} > {new Date(news.dateTime).toLocaleString()}</Typography>
                      <PersonIcon sx={{ marginRight: 1, fontSize: "14px", color: darkMode ? "var(--lightText)" : 'var(--darkText)', }} />
                      <Typography color="textSecondary" sx={{ marginRight: 2, fontSize: "12px" }}> {news.newsProviderName}</Typography>
                    </Box>
                  </Box>
                </ListItem>
              ))}
            </List>
          </PullToRefresh>
        </Box>
      </Box>
      <div style={{ height: 35 }}>
        <div style={{ marginTop: 3, marginLeft: 5 }}>
          <IconButton onClick={(e) => anchorEl ? handleCloseFilterMenu() : e.currentTarget && anchorEl === null && setAnchorEl(e.currentTarget)} sx={{ border: `1px solid #2e3338`, borderRadius: '3px', padding: '6px', marginRight: '6px', height: 30 }}>
            <CurrencyExchangeIcon sx={{ fontSize: 16, color: darkMode ? '#fff' : '#000' }} />
          </IconButton>
          <TextField size="small" variant="outlined" placeholder={t("mobSearch")} value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} sx={{ flex: 1, width: '250px' }} InputProps={{ sx: { fontSize: 13, padding: 0, height: 30, "& input": { padding: "0", paddingLeft: 1, height: "30px", }, }, }} />

          <Popover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleCloseFilterMenu} anchorOrigin={{ vertical: "top", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}>
            <MenuList sx={{ backgroundColor: darkMode ? "#202933" : "#d5d5d5", }}>
              {newsProviderName.length > 0 && (
                <MenuItem onClick={() => handleSelectSymbol("All")} sx={{ fontSize: 13.5, }}>{t('allNewsProvider')}</MenuItem>
              )}
              {newsProviderName.length > 0 ? newsProviderName.map((symbol, index) => (
                <MenuItem key={index} onClick={() => handleSelectSymbol(symbol)} sx={{ fontSize: 13.5, }}>{symbol}</MenuItem>
              )) : <MenuItem disabled sx={{ fontSize: 13.5, }}>{t('noNewsProvider')}</MenuItem>}
            </MenuList>
          </Popover>
        </div>      </div>
    </>
  );
}

